export default "__VITE_ASSET__DPOd8uNW__"